//Карта сайта,slidePanel
jQuery(function($) {
    $('#siteMapPanelButton').slidePanel();
    sessionStorage.setItem('open_slide_panel',1);
});

$(document).ready(function() {
    sessionStorage.setItem('open_slide_panel',0);
    fixHeadTable();
});

$(document).on('click', '#closeslide', function(){
    $('#siteMapPanelButton').slidePanel('hide');
});
//Нажатие на "Карта сайта"
$('#siteMapPanelButton').on('click', function () {
    let open_slide_panel=sessionStorage.getItem('open_slide_panel');
    if (open_slide_panel==1){
        $('#siteMapPanelButton').slidePanel('hide');
        sessionStorage.setItem('open_slide_panel',0);
    } else {
        $('#siteMapPanelButton').slidePanel('show');
        sessionStorage.setItem('open_slide_panel',1);
    }
    return false;
});
//Срабатывает, когда slidePanel закрылась
$(document).on('slidePanel::afterHide', function (e) {
    sessionStorage.setItem('open_slide_panel',0);
});
function fixHeadTable() {
    if (Object && QList && Object.keys(QList)[0]) {
        QList[Object.keys(QList)[0]].Tab.oList.oTable.fixedHeader.adjust();
    }
};
if('ResizeObserver' in window && document.getElementById('pageBlock'))
    new ResizeObserver((e) => fixHeadTable()).observe(document.getElementById('pageBlock'));
else {
    $(document).on('click', '#menu-opener', function () {
        let timerFix = setInterval(fixHeadTable, 20),
            stopTimer = () => clearInterval(timerFix);
        $('#pageBlock').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            setTimeout(stopTimer, 300);
        });
        setTimeout(stopTimer, 3000);
    });
}

//END Карта сайта
// menubar
//При нажатие на иконку меню, страничка сдвигается menubar
$(document).on('click', '#menu-opener', function () {
    if (!$('body').hasClass('site-menubar-open')){
        $('#pageBlock').css('margin-left',$('.site-menubar').width());
        $('#site-footer').css('margin-left',$('.site-menubar').width());
        sessionStorage.setItem('openmenu',1);
    } else {
        $('#pageBlock').css('margin-left',0);
        $('#site-footer').css('margin-left',0);
        sessionStorage.setItem('openmenu',0)
    }
});